export const errors = {
  "403": "Você não tem acesso a esta página.",
  "404": "Esta página não parece existir.\nEla pode ter sido excluída ou movida.",
  "500": "A aplicação encontrou um erro desconhecido. Tente novamente após alguns instantes.",
  "502": "Algo deu errado. Tente novamente após alguns instantes.",
  "403_action": "Você não tem permissão para executar esta ação.",
  "404_action": "Este objeto não existe.\nEle pode ter sido excluído ou movido.",
  authError: "Ocorreu um erro durante o fluxo de login. Por favor, tente novamente.",
  authLinkError:
    "Algo deu errado. Provavelmente você usou a URL incorreta para acessar esta página. Volte para a página inicial e tente novamente.",
  fetch_error: "A rede está inacessível. Tente novamente após alguns instantes.",
  incorrect_url: "Esta url está incorreta.",
  no_tenant: "Você deve entrar em contato com um administrador.",
  superadmin_no_tenant: "Você deve escolher o locatário primeiro ou definir o padrão.",
  Take_me_home: "Leve-me para casa",
  Try_again: "Tente novamente",
  unknown: "A aplicação encontrou um erro desconhecido. Tente novamente após alguns instantes.",
  if_error_persists: "Se o erro persistir, entre em contato com a <a>equipe de suporte</a>",
  mapping_download_error: "Ocorreu um erro durante o download do mapeamento",
} as const;
